<template>
  <CCallout v-bind="$attrs">
    <slot />
  </CCallout>
</template>
<script>
/**
 * RCallout
 *
 * Wrapper for CCallout with updated styles.
 */
export default {
  name: 'RCallout'
}
</script>
<style lang="scss" scoped>
.c-callout {
  background-color: rgba($info, 0.2);
  font-weight: 500;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 1rem;
  margin: 0 0 1rem;
}
</style>
